import React from "react";
import { Card } from "react-bootstrap";
import "../../Styles/cards.css";
import "../../Styles/styles.css";
import Rating from "../../Components/Rating";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "../../store/actions/cartActions";
function Product({ data }) {
  const dispatch = useDispatch();
  const cart = useSelector((state) => state.cart);
  const { cartItems } = cart;

  const items = cartItems.filter((q) => q.product === data._id);

  function showAdd(key, arr) {
    let found = false;
    for (let i = 0; i < arr.length; i++) {
      if (arr[i] === key) {
        found = true;
        return `Added In Cart (${items.map((q) => q.qty)})`;
      }
    }

    if (!found) {
      return "Add To Cart";
    }
    return found;
  }

  return (
    <div className="pr10 pb10" key={data._id}>
      <Card style={{ width: "18rem" }}>
        <Link to={`/product/${data._id}`}>
          <Card.Img
            className="border-0"
            height="240vh"
            variant="top"
            src={data.image.map((img, i) => img.coverimg)}
            alt={data.name}
          />
        </Link>
        <Card.Body>
          <Link to={`/product/${data._id}`} className="tdnone text-dark">
            <Card.Title>{data.name}</Card.Title>
          </Link>
          <Card.Text className="paragraph">{data.description}</Card.Text>
          <Card.Text className="priceTag">
            <span>{" $" + data.price}</span>
            <Button
              onClick={() => {
                dispatch(
                  addToCart(data._id, Number(items.map((q) => q.qty)) + 1)
                );
              }}
              disabled={
                (data.countInStock === 0 || Number(items.map((q) => q.qty))) >=
                  data.countInStock || false
              }
              variant="warning"
            >
              {showAdd(
                data._id,
                cartItems.map((id) => id.product)
              )}
            </Button>
          </Card.Text>
          <div className="flexStart">
            <div>
              <Rating rating={data.rating} numOfReviews={data.numOfReviews} />
            </div>
            <div className="reviews">{data.numReviews + " Reviews"}</div>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
}

export default Product;
